import React from "react";
import style from "./style.module.scss";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";

function FilterDrawer() {
  const filterDrawerOpen = useCommonStore((state) => state.filterDrawerOpen);
  const setFilterDrawerOpen = useCommonStore(
    (state) => state.setFilterDrawerOpen,
  );

  return (
    <Drawer
      open={filterDrawerOpen}
      direction="right"
      className={style.filter_drawer}
      size={"auto"}
      zIndex={999}
      overlayColor={"#000"}
      overlayOpacity={0.5}
    >
      <div className={style.drawer_container}>
        <div className={style.head}>
          <ButtonIcon onClick={() => setFilterDrawerOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#A4A3A8"
              />
            </svg>
          </ButtonIcon>
        </div>

        <div className={style.header}>
          <h5>Filter</h5>
        </div>

        <div className={style.content}>
          <div className={style.status_section}>
            <h6 className={style.title}>STATUS</h6>

            <div className={style.status_container}>
              <div className={style.status_item}>
                <input type="checkbox" name="" id="" />
                <span className={`${style.icon_label} ${style.text_green}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51774 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM8.14031 5.14031L5.51531 7.76531C5.48049 7.80018 5.43913 7.82784 5.3936 7.84671C5.34808 7.86558 5.29928 7.87529 5.25 7.87529C5.20072 7.87529 5.15192 7.86558 5.1064 7.84671C5.06088 7.82784 5.01952 7.80018 4.98469 7.76531L3.85969 6.64031C3.78932 6.56995 3.74979 6.47451 3.74979 6.375C3.74979 6.27549 3.78932 6.18005 3.85969 6.10969C3.93005 6.03932 4.02549 5.99979 4.125 5.99979C4.22451 5.99979 4.31995 6.03932 4.39031 6.10969L5.25 6.96984L7.60969 4.60969C7.64453 4.57485 7.68589 4.54721 7.73142 4.52835C7.77694 4.5095 7.82573 4.49979 7.875 4.49979C7.92428 4.49979 7.97307 4.5095 8.01859 4.52835C8.06411 4.54721 8.10547 4.57485 8.14031 4.60969C8.17516 4.64453 8.20279 4.68589 8.22165 4.73141C8.24051 4.77694 8.25021 4.82573 8.25021 4.875C8.25021 4.92427 8.24051 4.97306 8.22165 5.01859C8.20279 5.06411 8.17516 5.10547 8.14031 5.14031Z"
                      fill="#37B450"
                    />
                  </svg>
                  Active
                </span>
              </div>

              <div className={style.status_item}>
                <input type="checkbox" name="" id="" />
                <span className={`${style.icon_label} ${style.text_grey}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51774 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM7.76531 7.76531C7.73049 7.80018 7.68913 7.82784 7.6436 7.84671C7.59808 7.86558 7.54928 7.87529 7.5 7.87529C7.45072 7.87529 7.40192 7.86558 7.3564 7.84671C7.31088 7.82784 7.26952 7.80018 7.23469 7.76531L4.23469 4.76531C4.16432 4.69495 4.12479 4.59951 4.12479 4.5C4.12479 4.40049 4.16432 4.30505 4.23469 4.23469C4.30505 4.16432 4.40049 4.12479 4.5 4.12479C4.59951 4.12479 4.69495 4.16432 4.76531 4.23469L7.76531 7.23469C7.80018 7.26951 7.82784 7.31087 7.84671 7.3564C7.86558 7.40192 7.8753 7.45072 7.8753 7.5C7.8753 7.54928 7.86558 7.59808 7.84671 7.6436C7.82784 7.68913 7.80018 7.73049 7.76531 7.76531Z"
                      fill="#89888D"
                    />
                  </svg>
                  Closed
                </span>
              </div>

              <div className={style.status_item}>
                <input type="checkbox" name="" id="" />
                <span className={`${style.icon_label} ${style.text_blue}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51774 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM8.625 6.375H6.90516L8.14031 7.60969C8.17516 7.64453 8.20279 7.68589 8.22165 7.73141C8.24051 7.77694 8.25021 7.82573 8.25021 7.875C8.25021 7.92427 8.24051 7.97306 8.22165 8.01859C8.20279 8.06411 8.17516 8.10547 8.14031 8.14031C8.10547 8.17515 8.06411 8.20279 8.01859 8.22165C7.97307 8.2405 7.92428 8.25021 7.875 8.25021C7.82573 8.25021 7.77694 8.2405 7.73142 8.22165C7.68589 8.20279 7.64453 8.17515 7.60969 8.14031L5.73469 6.26531C5.68219 6.21287 5.64642 6.14602 5.63193 6.07324C5.61743 6.00046 5.62486 5.92501 5.65327 5.85645C5.68168 5.78789 5.72979 5.72931 5.79151 5.6881C5.85323 5.6469 5.92579 5.62494 6 5.625H8.625C8.72446 5.625 8.81984 5.66451 8.89017 5.73484C8.96049 5.80516 9 5.90054 9 6C9 6.09946 8.96049 6.19484 8.89017 6.26517C8.81984 6.33549 8.72446 6.375 8.625 6.375Z"
                      fill="#4C70EF"
                    />
                  </svg>
                  Idle
                </span>
              </div>
            </div>
          </div>

          <div style={style.field_container}>
            <div className={style.field_header}>
              <h6>Volume Cap</h6>
            </div>
            <div className={style.field_body}>
              <div className={style.form_group}>
                <label>Volume From</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>$</span>
                  <input type="text" placeholder="0.0" />
                </div>
              </div>
              <div className={style.form_group}>
                <label>Volume To</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>$</span>
                  <input type="text" placeholder="0.0" />
                </div>
              </div>
            </div>
          </div>

          <div style={style.field_container}>
            <div className={style.field_header}>
              <h6>Volume Used</h6>
            </div>
            <div className={style.field_body}>
              <div className={style.form_group}>
                <label>Volume From</label>
                <div className={style.field_input}>
                  <input type="text" placeholder="0.0" />
                  <span className={style.field_icon}>$</span>
                </div>
              </div>
              <div className={style.form_group}>
                <label>Volume To</label>
                <div className={style.field_input}>
                  <input type="text" placeholder="0.0" />
                  <span className={style.field_icon}>$</span>
                </div>
              </div>
            </div>
          </div>

          <div style={style.field_container}>
            <div className={style.field_header}>
              <h6>Volume MTD</h6>
            </div>
            <div className={style.field_body}>
              <div className={style.form_group}>
                <label>Volume From</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>$</span>
                  <input type="text" placeholder="0.0" />
                </div>
              </div>
              <div className={style.form_group}>
                <label>Volume To</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>$</span>
                  <input type="text" placeholder="0.0" />
                </div>
              </div>
            </div>
          </div>

          <div style={style.field_container}>
            <div className={style.field_header}>
              <h6>MOM Change</h6>
            </div>
            <div className={style.field_body}>
              <div className={style.form_group}>
                <label>MOM From</label>
                <div className={style.field_input}>
                  <input type="text" placeholder="0.0" />
                  <span className={style.field_icon}>$</span>
                </div>
              </div>
              <div className={style.form_group}>
                <label>MOM To</label>
                <div className={style.field_input}>
                  <input type="text" placeholder="0.0" />
                  <span className={style.field_icon}>$</span>
                </div>
              </div>
            </div>
          </div>

          <div style={style.field_container}>
            <div className={style.field_header}>
              <h6>Date approved</h6>
            </div>
            <div className={style.field_body}>
              <div className={style.form_group}>
                <label>Date From</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13 2H11.5V1.5C11.5 1.36739 11.4473 1.24021 11.3536 1.14645C11.2598 1.05268 11.1326 1 11 1C10.8674 1 10.7402 1.05268 10.6464 1.14645C10.5527 1.24021 10.5 1.36739 10.5 1.5V2H5.5V1.5C5.5 1.36739 5.44732 1.24021 5.35355 1.14645C5.25979 1.05268 5.13261 1 5 1C4.86739 1 4.74021 1.05268 4.64645 1.14645C4.55268 1.24021 4.5 1.36739 4.5 1.5V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM4.5 3V3.5C4.5 3.63261 4.55268 3.75979 4.64645 3.85355C4.74021 3.94732 4.86739 4 5 4C5.13261 4 5.25979 3.94732 5.35355 3.85355C5.44732 3.75979 5.5 3.63261 5.5 3.5V3H10.5V3.5C10.5 3.63261 10.5527 3.75979 10.6464 3.85355C10.7402 3.94732 10.8674 4 11 4C11.1326 4 11.2598 3.94732 11.3536 3.85355C11.4473 3.75979 11.5 3.63261 11.5 3.5V3H13V5H3V3H4.5ZM13 13H3V6H13V13ZM8.75 8.25C8.75 8.39834 8.70601 8.54334 8.6236 8.66668C8.54119 8.79001 8.42406 8.88614 8.28701 8.94291C8.14997 8.99967 7.99917 9.01453 7.85368 8.98559C7.7082 8.95665 7.57456 8.88522 7.46967 8.78033C7.36478 8.67544 7.29335 8.5418 7.26441 8.39632C7.23547 8.25083 7.25032 8.10003 7.30709 7.96299C7.36386 7.82594 7.45999 7.70881 7.58332 7.6264C7.70666 7.54399 7.85166 7.5 8 7.5C8.19891 7.5 8.38968 7.57902 8.53033 7.71967C8.67098 7.86032 8.75 8.05109 8.75 8.25ZM11.5 8.25C11.5 8.39834 11.456 8.54334 11.3736 8.66668C11.2912 8.79001 11.1741 8.88614 11.037 8.94291C10.9 8.99967 10.7492 9.01453 10.6037 8.98559C10.4582 8.95665 10.3246 8.88522 10.2197 8.78033C10.1148 8.67544 10.0433 8.5418 10.0144 8.39632C9.98547 8.25083 10.0003 8.10003 10.0571 7.96299C10.1139 7.82594 10.21 7.70881 10.3333 7.6264C10.4567 7.54399 10.6017 7.5 10.75 7.5C10.9489 7.5 11.1397 7.57902 11.2803 7.71967C11.421 7.86032 11.5 8.05109 11.5 8.25ZM6 10.75C6 10.8983 5.95601 11.0433 5.8736 11.1667C5.79119 11.29 5.67406 11.3861 5.53701 11.4429C5.39997 11.4997 5.24917 11.5145 5.10368 11.4856C4.9582 11.4567 4.82456 11.3852 4.71967 11.2803C4.61478 11.1754 4.54335 11.0418 4.51441 10.8963C4.48547 10.7508 4.50032 10.6 4.55709 10.463C4.61386 10.3259 4.70999 10.2088 4.83332 10.1264C4.95666 10.044 5.10166 10 5.25 10C5.44891 10 5.63968 10.079 5.78033 10.2197C5.92098 10.3603 6 10.5511 6 10.75ZM8.75 10.75C8.75 10.8983 8.70601 11.0433 8.6236 11.1667C8.54119 11.29 8.42406 11.3861 8.28701 11.4429C8.14997 11.4997 7.99917 11.5145 7.85368 11.4856C7.7082 11.4567 7.57456 11.3852 7.46967 11.2803C7.36478 11.1754 7.29335 11.0418 7.26441 10.8963C7.23547 10.7508 7.25032 10.6 7.30709 10.463C7.36386 10.3259 7.45999 10.2088 7.58332 10.1264C7.70666 10.044 7.85166 10 8 10C8.19891 10 8.38968 10.079 8.53033 10.2197C8.67098 10.3603 8.75 10.5511 8.75 10.75ZM11.5 10.75C11.5 10.8983 11.456 11.0433 11.3736 11.1667C11.2912 11.29 11.1741 11.3861 11.037 11.4429C10.9 11.4997 10.7492 11.5145 10.6037 11.4856C10.4582 11.4567 10.3246 11.3852 10.2197 11.2803C10.1148 11.1754 10.0433 11.0418 10.0144 10.8963C9.98547 10.7508 10.0003 10.6 10.0571 10.463C10.1139 10.3259 10.21 10.2088 10.3333 10.1264C10.4567 10.044 10.6017 10 10.75 10C10.9489 10 11.1397 10.079 11.2803 10.2197C11.421 10.3603 11.5 10.5511 11.5 10.75Z"
                        fill="#3A383F"
                      />
                    </svg>
                  </span>
                  <input type="text" placeholder="01/01/2017" />
                </div>
              </div>
              <div className={style.form_group}>
                <label>Date To</label>
                <div className={style.field_input}>
                  <span className={style.field_icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13 2H11.5V1.5C11.5 1.36739 11.4473 1.24021 11.3536 1.14645C11.2598 1.05268 11.1326 1 11 1C10.8674 1 10.7402 1.05268 10.6464 1.14645C10.5527 1.24021 10.5 1.36739 10.5 1.5V2H5.5V1.5C5.5 1.36739 5.44732 1.24021 5.35355 1.14645C5.25979 1.05268 5.13261 1 5 1C4.86739 1 4.74021 1.05268 4.64645 1.14645C4.55268 1.24021 4.5 1.36739 4.5 1.5V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM4.5 3V3.5C4.5 3.63261 4.55268 3.75979 4.64645 3.85355C4.74021 3.94732 4.86739 4 5 4C5.13261 4 5.25979 3.94732 5.35355 3.85355C5.44732 3.75979 5.5 3.63261 5.5 3.5V3H10.5V3.5C10.5 3.63261 10.5527 3.75979 10.6464 3.85355C10.7402 3.94732 10.8674 4 11 4C11.1326 4 11.2598 3.94732 11.3536 3.85355C11.4473 3.75979 11.5 3.63261 11.5 3.5V3H13V5H3V3H4.5ZM13 13H3V6H13V13ZM8.75 8.25C8.75 8.39834 8.70601 8.54334 8.6236 8.66668C8.54119 8.79001 8.42406 8.88614 8.28701 8.94291C8.14997 8.99967 7.99917 9.01453 7.85368 8.98559C7.7082 8.95665 7.57456 8.88522 7.46967 8.78033C7.36478 8.67544 7.29335 8.5418 7.26441 8.39632C7.23547 8.25083 7.25032 8.10003 7.30709 7.96299C7.36386 7.82594 7.45999 7.70881 7.58332 7.6264C7.70666 7.54399 7.85166 7.5 8 7.5C8.19891 7.5 8.38968 7.57902 8.53033 7.71967C8.67098 7.86032 8.75 8.05109 8.75 8.25ZM11.5 8.25C11.5 8.39834 11.456 8.54334 11.3736 8.66668C11.2912 8.79001 11.1741 8.88614 11.037 8.94291C10.9 8.99967 10.7492 9.01453 10.6037 8.98559C10.4582 8.95665 10.3246 8.88522 10.2197 8.78033C10.1148 8.67544 10.0433 8.5418 10.0144 8.39632C9.98547 8.25083 10.0003 8.10003 10.0571 7.96299C10.1139 7.82594 10.21 7.70881 10.3333 7.6264C10.4567 7.54399 10.6017 7.5 10.75 7.5C10.9489 7.5 11.1397 7.57902 11.2803 7.71967C11.421 7.86032 11.5 8.05109 11.5 8.25ZM6 10.75C6 10.8983 5.95601 11.0433 5.8736 11.1667C5.79119 11.29 5.67406 11.3861 5.53701 11.4429C5.39997 11.4997 5.24917 11.5145 5.10368 11.4856C4.9582 11.4567 4.82456 11.3852 4.71967 11.2803C4.61478 11.1754 4.54335 11.0418 4.51441 10.8963C4.48547 10.7508 4.50032 10.6 4.55709 10.463C4.61386 10.3259 4.70999 10.2088 4.83332 10.1264C4.95666 10.044 5.10166 10 5.25 10C5.44891 10 5.63968 10.079 5.78033 10.2197C5.92098 10.3603 6 10.5511 6 10.75ZM8.75 10.75C8.75 10.8983 8.70601 11.0433 8.6236 11.1667C8.54119 11.29 8.42406 11.3861 8.28701 11.4429C8.14997 11.4997 7.99917 11.5145 7.85368 11.4856C7.7082 11.4567 7.57456 11.3852 7.46967 11.2803C7.36478 11.1754 7.29335 11.0418 7.26441 10.8963C7.23547 10.7508 7.25032 10.6 7.30709 10.463C7.36386 10.3259 7.45999 10.2088 7.58332 10.1264C7.70666 10.044 7.85166 10 8 10C8.19891 10 8.38968 10.079 8.53033 10.2197C8.67098 10.3603 8.75 10.5511 8.75 10.75ZM11.5 10.75C11.5 10.8983 11.456 11.0433 11.3736 11.1667C11.2912 11.29 11.1741 11.3861 11.037 11.4429C10.9 11.4997 10.7492 11.5145 10.6037 11.4856C10.4582 11.4567 10.3246 11.3852 10.2197 11.2803C10.1148 11.1754 10.0433 11.0418 10.0144 10.8963C9.98547 10.7508 10.0003 10.6 10.0571 10.463C10.1139 10.3259 10.21 10.2088 10.3333 10.1264C10.4567 10.044 10.6017 10 10.75 10C10.9489 10 11.1397 10.079 11.2803 10.2197C11.421 10.3603 11.5 10.5511 11.5 10.75Z"
                        fill="#3A383F"
                      />
                    </svg>
                  </span>
                  <input type="text" placeholder="01/01/2017" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={style.footer}>
          <ButtonIcon bgColor={"#EDEDF4"} textColor="#050506">
            Clear
          </ButtonIcon>
          <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF">
            Apply
          </ButtonIcon>
        </div>
      </div>
    </Drawer>
  );
}

export default FilterDrawer;
